<script setup>
import ApikomTaskTimeTable from "@frontJs/components/tables/projectManagement/tasks/ApikomTaskTimeTable.vue";
import ProjectManagementLayout from "@frontJs/layouts/ProjectManagementLayout.vue";
import { Head } from "@inertiajs/vue3";
import LoadingSpinner from "@js/components/LoadingSpinner.vue";
import PageTitle from "@js/components/titles/PageTitle.vue";
import TabGroup from "@js/components/tabs/TabGroup.vue";
import TabPanel from "@js/components/tabs/TabPanel.vue";
import { useRoute } from "@js/utils/route";
import { onMounted, ref } from "vue";
import { useI18n } from "vue-i18n";

const { t } = useI18n();

const { route } = useRoute();

const loading = ref(true);

const selectedTab = ref(0);

const validateCount = ref(0);

function changeTab(index) {
  selectedTab.value = index;
}

function updateData() {
  loading.value = true;

  let url = route(
    "front.projectManagement.task.getTaskTimesToValidateCount",
  );

  axios
    .get(url)
    .then((response) => {
      validateCount.value = response.data.count;
    })
    .catch((error) => {
      console.log(error);
    })
    .finally(() => {
      loading.value = false;
    });
}

onMounted(() => {
  updateData();
});

defineOptions({ layout: ProjectManagementLayout });
</script>

<template>
  <Head>
    <title>
      {{ t("title.apikomTime") }} - {{ t("title.tasks") }} -
      {{ t("title.projectManagement") }} - {{ t("title.datakepler") }}
    </title>
  </Head>

  <PageTitle>
    {{ t("title.projectManagement") }} - {{ t("title.tasks") }} -
    {{ t("title.apikomTime") }}
  </PageTitle>

  <LoadingSpinner v-if="loading" />

  <TabGroup
    v-else
    :selected-tab="selectedTab"
    :change-tab="changeTab"
    :tabs="{
      toValidateHourlyPackageAndProject:
        t('title.toValidateHourlyPackageAndProject') +
        ' (' +
        validateCount +
        ')',
      allHourlyPackageAndProject: t('title.allHourlyPackageAndProject'),
      hourlyValidatedTime: t('title.hourlyValidatedTime'),
      packageTime: t('title.packageTime'),
      projectTime: t('title.projectTime'),
    }"
  >
    >
    <template #panels>
      <TabPanel without-background :unmount="true">
        <ApikomTaskTimeTable
          user-session-key="task_times_to_validate"
          to-validate
        />
      </TabPanel>

      <TabPanel without-background :unmount="true">
        <ApikomTaskTimeTable user-session-key="task_times" />
      </TabPanel>

      <TabPanel without-background :unmount="true">
        <ApikomTaskTimeTable
          user-session-key="task_times_hourly_validated"
          type="hourly"
          validated
        />
      </TabPanel>

      <TabPanel without-background :unmount="true">
        <ApikomTaskTimeTable
          user-session-key="task_times_package_validated"
          type="package"
          validated
        />
      </TabPanel>

      <TabPanel without-background :unmount="true">
        <ApikomTaskTimeTable
          user-session-key="task_times_project_validated"
          type="project"
          validated
        />
      </TabPanel>
    </template>
  </TabGroup>
</template>
